import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import useOffersData from "../hooks/useOffersData";
import useStockData from "../hooks/useStockData";
// import OfferProductModal from "./OfferProductModal";
import { useTheme } from "../context/ThemeContext";
import { IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { TextField, MenuItem } from "@mui/material";
import { getUserData } from "../utils/Auth";
import { Autocomplete } from "@mui/material";

Modal.setAppElement("#root");

const EditOfferModal = ({ isOpen, onClose, onOfferEdited, offerData }) => {
  const { updateOffer } = useOffersData();
  const { allProducts, fetchAllProducts } = useStockData();
  const { darkMode } = useTheme(); // 🔥 Dark mode állapot lekérése

  const [customerName, setCustomerName] = useState("");
  const [discount, setDiscount] = useState(0);
  const [items, setItems] = useState([]);
  // const [isProductModalOpen, setIsProductModalOpen] = useState(false);
  const [successMessage, setSuccessMessage] = useState(""); // ✅ Sikerüzenet state
  const [useMarmuristPricing, setUseMarmuristPricing] = useState(false);
  const [notita, setNotita] = useState("");
  const [customerPhone, setCustomerPhone] = useState("");
  const [canAccessMarmurist, setCanAccessMarmurist] = useState(false);
  const [tipClient, setTipClient] = useState(0);
  const [pretMontaj, setPretMontaj] = useState(0);
  const [pretLivrare, setPretLivrare] = useState(0);
  const [livrareRuta, setLivrareRuta] = useState("");
  const [cantitateMontaj, setCantitateMontaj] = useState(0);
  const [preferentialPrice, setPreferentialPrice] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0);
  const [tva, setTva] = useState(0);
  const [totalWithTVA, setTotalWithTVA] = useState(0);
  const [lastModifiedField, setLastModifiedField] = useState(null);

  // 🔥 Ha megnyílik a modal, betöltjük az adatokat
  useEffect(() => {
    const fetchData = async () => {
      if (isOpen && offerData) {
        setCustomerName(offerData.customerName || "");
        setDiscount(offerData.discount || 0);
        setUseMarmuristPricing(offerData.useMarmuristPricing || false);
        setNotita(offerData.notita || "");
        setCustomerPhone(offerData.telefon || "");
        setTipClient(offerData.tipClient || 0);
        setPretMontaj(offerData.pretMontaj || 0);
        setPretLivrare(offerData.pretLivrare || 0);
        setLivrareRuta(offerData.livrareRuta || "");
        setCantitateMontaj(offerData.cantitateMontaj || 0);
        setPreferentialPrice(offerData.preferentialPrice || 0);
        setLastModifiedField("preferentialPrice");
        const transformedItems = offerData.items.map((item) => {
          let unitType = item.unitType || "MP";
          let quantityMP = item.quantityMP?.toString() || "";
          let quantityML = item.quantityML?.toString() || "";

          if (!item.unitType) {
            if (parseFloat(item.quantityML) > 0) {
              unitType = "ML";
            } else if (parseFloat(item.quantityMP) > 0) {
              unitType = "MP";
            }
          }

          console.log("offerData:", offerData);

          return {
            productId: item.productId,
            length: item.length?.toString() || "",
            width: item.width?.toString() || "",
            quantity: item.quantity?.toString() || "",
            unitType,
            quantityMP,
            quantityML,
            quantityBUC: item.quantityBUC?.toString() || "",
            customDescription: item.customDescription || "",
          };
        });
        setItems(transformedItems);
        fetchAllProducts();
        const userData = await getUserData();
        if (!userData?.canAccessMarmurist) {
          setCanAccessMarmurist(false);
          setUseMarmuristPricing(false); // <- force override
        } else {
          setCanAccessMarmurist(true);
        }
      }
    };
    fetchData();
  }, [isOpen, offerData]);

  useEffect(() => {
    const itemsSubtotal = items.reduce((acc, item) => {
      const mp = parseFloat(item.quantityMP) || 0;
      const ml = parseFloat(item.quantityML) || 0;
      const buc = parseInt(item.quantityBUC) || 0;

      const product = allProducts.find(
        (p) => p.id === parseInt(item.productId)
      );

      const unitType = product?.unitType || "MP";

      if (!product) return acc;

      const price = useMarmuristPricing
        ? product.priceMarmurist
        : product.price;

      let itemTotal = 0;
      if (ml > 0) {
        itemTotal = price * ml;
      } else if (buc > 0) {
        itemTotal = price * buc;
      } else {
        itemTotal = price * mp;
      }
      return acc + itemTotal;
    }, 0);

    const montajTotal =
      (parseFloat(pretMontaj) || 0) * (parseFloat(cantitateMontaj) || 0);
    const livrareTotal = parseFloat(pretLivrare) || 0;

    const netTotal = itemsSubtotal + montajTotal + livrareTotal;
    const calculatedTVA = parseFloat((netTotal * 0.21).toFixed(2));
    const gross = parseFloat((netTotal + calculatedTVA).toFixed(2));

    setTotalPrice(parseFloat(netTotal.toFixed(2))); // nettó
    setTva(calculatedTVA); // TVA
    setTotalWithTVA(gross); // bruttó
  }, [
    items,
    allProducts,
    useMarmuristPricing,
    pretMontaj,
    cantitateMontaj,
    pretLivrare,
  ]);

  useEffect(() => {
    const itemsSubtotal = items.reduce((acc, item) => {
      const mp = parseFloat(item.quantityMP) || 0;
      const ml = parseFloat(item.quantityML) || 0;
      const buc = parseInt(item.quantityBUC) || 0;

      const product = allProducts.find(
        (p) => p.id === parseInt(item.productId)
      );
      const unitType = product?.unitType || "MP";

      if (!product) return acc;

      const price = useMarmuristPricing
        ? product.priceMarmurist
        : product.price;

      let itemTotal = 0;
      if (ml > 0) {
        itemTotal = price * ml;
      } else if (buc > 0) {
        itemTotal = price * buc;
      } else {
        itemTotal = price * mp;
      }
      return acc + itemTotal;
    }, 0);

    const montajTotal =
      (parseFloat(pretMontaj) || 0) * (parseFloat(cantitateMontaj) || 0);
    const livrareTotal = parseFloat(pretLivrare) || 0;

    if (!itemsSubtotal || itemsSubtotal === 0) return;

    if (lastModifiedField === "preferentialPrice") {
      const netPreferential = preferentialPrice / 1.21;
      const discountValue =
        100 -
        ((netPreferential - montajTotal - livrareTotal) * 100) / itemsSubtotal;
      if (!isNaN(discountValue)) {
        setDiscount(parseFloat(discountValue.toFixed(2)));
      }
    }

    if (lastModifiedField === "discount") {
      const discountedItemsNet = itemsSubtotal * (1 - discount / 100);
      const netTotal = discountedItemsNet + montajTotal + livrareTotal;
      const gross = netTotal * 1.21;
      if (!isNaN(gross)) {
        setPreferentialPrice(parseFloat(gross.toFixed(2)));
      }
    }

    // setLastModifiedField(null);
  }, [
    preferentialPrice,
    discount,
    items,
    allProducts,
    useMarmuristPricing,
    pretMontaj,
    cantitateMontaj,
    pretLivrare,
    lastModifiedField,
  ]);

  useEffect(() => {
    if (
      totalPrice > 0 &&
      (preferentialPrice === null || preferentialPrice === 0)
    ) {
      setPreferentialPrice(parseFloat((totalPrice * 1.21).toFixed(2)));
    }
  }, [totalPrice, preferentialPrice]);

  const handleAddEmptyRow = () => {
    setItems((prevItems) => [
      ...prevItems,
      {
        productId: "",
        length: "",
        width: "",
        quantity: "",
        quantityMP: "",
        quantityML: "",
        quantityBUC: "",
      },
    ]);
  };

  // 🔥 Új termék hozzáadása a listához
  const handleAddItem = (product) => {
    if (!product || !product.productId) return;

    setItems([...items, product]);
    // setIsProductModalOpen(false);
  };

const handleItemChange = (index, field, value) => {
  const newItems = [...items];
  const item = newItems[index];

  if (field === "productId") {
    item.productId = value;
    // Reset csak akkor kell, ha egy teljesen másik terméket választasz!
    item.length = "";
    item.width = "";
    item.quantity = "";
    item.quantityMP = "";
    item.quantityML = "";
    item.quantityBUC = "";
    item.customDescription = "";
    setItems(newItems);
    return;
  }

  item[field] = value;

  // Ha L, W vagy Q változik, automatikusan számoljuk az MP-t.
  if (["length", "width", "quantity"].includes(field)) {
    const l = parseFloat(item.length) || 0;
    const w = parseFloat(item.width) || 0;
    const q = parseInt(item.quantity) || 0;
    const mp = (l * w * q) / 10000;
    item.quantityMP = isNaN(mp) ? "" : parseFloat(mp.toFixed(4));
  }

  setItems(newItems);
};

  // 🔥 Termék eltávolítása
  const handleRemoveItem = (index) => {
    setItems(items.filter((_, i) => i !== index));
  };

  // 🔥 Frissítés beküldése
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validáció, hogy ne küldjük el üresen az ajánlatot
    if (!customerName.trim() || items.length === 0) {
      alert(
        "A mezők nem lehetnek üresek, és legalább egy terméket hozzá kell adni!"
      );

      return;
    }

    const updatedOffer = {
      id: offerData.id,
      customerName,
      discount: parseFloat(discount),
      useMarmuristPricing,
      notita,
      telefon: customerPhone,
      tipClient,
      pretMontaj,
      pretLivrare,
      livrareRuta,
      cantitateMontaj,
      preferentialPrice: parseFloat(preferentialPrice) || null,
      items: items.map((item) => ({
        productId: parseInt(item.productId),
        quantityMP: parseFloat(item.quantityMP) || 0,
        quantityML: parseFloat(item.quantityML) || 0,
        quantityBUC: parseInt(item.quantityBUC) || 0,
        length: parseFloat(item.length) || 0,
        width: parseFloat(item.width) || 0,
        quantity: parseInt(item.quantity) || 0,
        customDescription: item.customDescription || "",
      })),
    };

    await updateOffer(updatedOffer);
    // ✅ Sikeres frissítés üzenet
    setSuccessMessage("✅ Ofertă modificată cu succes!");

    // 🔥 2 másodperc után töröljük az üzenetet és bezárjuk a modált
    setTimeout(() => {
      setSuccessMessage("");
      onOfferEdited();
      onClose();
    }, 2000);
  };

  return (
    isOpen && (
      <div
        className={`fixed inset-0 flex items-center justify-center bg-opacity-80 ${
          darkMode ? "bg-black" : "bg-gray-500"
        }`}
        onClick={(e) => {
          if (e.target === e.currentTarget) {
            onClose();
          }
        }}
      >
        <div
          className={`p-6 rounded-lg shadow-xl w-[65%] max-w-7xl max-h-[85vh] overflow-y-auto relative transition-colors ${
            darkMode ? "bg-gray-900 text-white" : "bg-white text-gray-900"
          }`}
          onClick={(e) => e.stopPropagation()}
        >
          {/* ✅ Sikeres visszajelzés megjelenítése */}
          {successMessage && (
            <div className="absolute top-4 left-1/2 transform -translate-x-1/2 bg-green-500 text-white px-4 py-2 rounded-lg shadow-md">
              {successMessage}
            </div>
          )}
          <button
            onClick={onClose}
            className="absolute top-2 right-3 text-red-500 hover:text-red-700 text-2xl"
          >
            ✖
          </button>

          <h2
            className={`text-2xl font-semibold mb-4 text-center ${
              darkMode ? "text-blue-400" : "text-blue-600"
            }`}
          >
            Editare Ofertă #{offerData.nr}
          </h2>
          <form className="space-y-4" onSubmit={handleSubmit}>
            <div className="w-full flex flex-wrap gap-4 items-end">
              {/* Nume client */}
              <div className="flex-1 min-w-[180px]">
                <label className="block font-semibold mb-1 text-sm">
                  Nume client:
                </label>
                <input
                  type="text"
                  value={customerName}
                  onChange={(e) => setCustomerName(e.target.value)}
                  className={`w-full p-2 border rounded-2xl ${
                    darkMode
                      ? "border-gray-600 bg-gray-800 text-white"
                      : "border-gray-300 bg-white text-black"
                  }`}
                />
              </div>

              {/* Tip client */}
              <div className="flex-1 min-w-[160px]">
                <label className="block font-semibold mb-1 text-sm">
                  Tip client:
                </label>
                <select
                  value={tipClient}
                  onChange={(e) => setTipClient(parseInt(e.target.value))}
                  className={`w-full p-2 border rounded-2xl ${
                    darkMode
                      ? "border-gray-600 bg-gray-800 text-white"
                      : "border-gray-300 bg-white text-black"
                  }`}
                >
                  <option value={0}>Persoană Fizică</option>
                  <option value={1}>Persoană Juridică</option>
                </select>
              </div>

              {/* Număr de telefon */}
              <div className="flex-1 min-w-[180px]">
                <label className="block font-semibold mb-1 text-sm">
                  Număr de telefon:
                </label>
                <input
                  type="tel"
                  inputMode="numeric"
                  pattern="^\+?\d{0,15}$"
                  maxLength={15}
                  value={customerPhone}
                  onChange={(e) => {
                    const val = e.target.value;
                    if (/^\+?\d*$/.test(val)) {
                      setCustomerPhone(val);
                    }
                  }}
                  className={`w-full p-2 border rounded-2xl ${
                    darkMode
                      ? "border-gray-600 bg-gray-800 text-white"
                      : "border-gray-300 bg-white text-black"
                  }`}
                />
              </div>

              {/* Folosește preț Marmurist */}
              {canAccessMarmurist && (
                <div className="flex items-center min-w-[200px] mb-2 pt-[30px]">
                  <label className="flex items-center font-semibold">
                    <input
                      type="checkbox"
                      checked={useMarmuristPricing}
                      onChange={(e) => setUseMarmuristPricing(e.target.checked)}
                      className="mr-2 w-5 h-5"
                    />
                    Folosește preț Marmurist
                  </label>
                </div>
              )}
            </div>

            <div className="w-full mt-2">
              <label
                className={`block font-semibold mb-1 ${
                  darkMode ? "text-gray-300" : "text-gray-700"
                }`}
              >
                Notiță (opțional):
              </label>
              <textarea
                rows={3}
                value={notita}
                onChange={(e) => setNotita(e.target.value)}
                className={`w-full p-2 border rounded-2xl resize-none ${
                  darkMode
                    ? "border-gray-600 bg-gray-800 text-white"
                    : "border-gray-300 bg-white text-black"
                }`}
                placeholder="Observații, note interne etc."
              />
            </div>

            <div className="flex flex-wrap gap-4 w-full">
              <div className="flex-1 min-w-[200px]">
                <label
                  className={`block font-semibold mb-1 ${
                    darkMode ? "text-gray-300" : "text-gray-700"
                  }`}
                >
                  Preț montaj (EUR):
                </label>
                <input
                  type="number"
                  min="0"
                  value={pretMontaj}
                  onChange={(e) => setPretMontaj(parseFloat(e.target.value))}
                  className={`w-full p-2 border rounded-2xl ${
                    darkMode
                      ? "border-gray-600 bg-gray-800 text-white"
                      : "border-gray-300 bg-white text-black"
                  }`}
                />
              </div>

              <div className="flex-1 min-w-[200px]">
                <label
                  className={`block font-semibold mb-1 ${
                    darkMode ? "text-gray-300" : "text-gray-700"
                  }`}
                >
                  Cantitate montaj:
                </label>
                <input
                  type="number"
                  min="0"
                  step="any"
                  value={cantitateMontaj}
                  onChange={(e) =>
                    setCantitateMontaj(parseFloat(e.target.value))
                  }
                  className={`w-full p-2 border rounded-2xl ${
                    darkMode
                      ? "border-gray-600 bg-gray-800 text-white"
                      : "border-gray-300 bg-white text-black"
                  }`}
                />
              </div>

              <div className="flex-1 min-w-[300px]">
                <label
                  className={`block font-semibold mb-1 ${
                    darkMode ? "text-gray-300" : "text-gray-700"
                  }`}
                >
                  Preț livrare (EUR):
                </label>
                <input
                  type="number"
                  min="0"
                  value={pretLivrare}
                  onChange={(e) => setPretLivrare(parseFloat(e.target.value))}
                  className={`w-full p-2 border rounded-2xl ${
                    darkMode
                      ? "border-gray-600 bg-gray-800 text-white"
                      : "border-gray-300 bg-white text-black"
                  }`}
                />
              </div>

              <div className="flex-1 min-w-[300px]">
                <label
                  className={`block font-semibold mb-1 ${
                    darkMode ? "text-gray-300" : "text-gray-700"
                  }`}
                >
                  Rută livrare (opțional):
                </label>
                <input
                  type="text"
                  placeholder="Ex: Oradea - Cluj"
                  value={livrareRuta}
                  onChange={(e) => setLivrareRuta(e.target.value)}
                  className={`w-full p-2 border rounded-2xl ${
                    darkMode
                      ? "border-gray-600 bg-gray-800 text-white"
                      : "border-gray-300 bg-white text-black"
                  }`}
                />
              </div>
            </div>

            <h3 className="text-lg font-semibold mt-4">Produse</h3>

            {items.length > 0 && (
              <div className="overflow-x-auto">
                <table
                  className={`w-full border shadow-lg ${
                    darkMode
                      ? "border-gray-700 bg-gray-900 text-gray-300"
                      : "border-gray-400 bg-white text-gray-800"
                  }`}
                >
                  <thead>
                    <tr
                      className={`${
                        darkMode
                          ? "bg-gray-700 text-white"
                          : "bg-gray-300 text-black"
                      }`}
                    >
                      <th className="border p-2 w-[20%]">Material</th>
                      <th className="border p-2 w-[14%]">Descriere</th>
                      <th className="border p-2 w-[10%]">Lungime</th>
                      <th className="border p-2 w-[10%]">Latime</th>
                      <th className="border p-2 w-[10%]">Bucăți</th>
                      <th className="border p-2 w-[6%]">MP</th>
                      <th className="border p-2 w-[6%]">ML</th>
                      <th className="border p-2 w-[7%]">BUC</th>
                      <th className="border p-2 w-[8%]">Acțiuni</th>
                    </tr>
                  </thead>

                  <tbody>
                    {items.map((item, index) => {
                      const product = allProducts.find(
                        (p) => p.id === parseInt(item.productId)
                      );
                      const unitType = product?.unitType || "MP";

                      return (
                        <tr key={index}>
                          <td className="border p-1 min-w-[350px] max-w-[500px]">
                            {allProducts.length > 0 && (
                              <Autocomplete
                                options={allProducts}
                                getOptionLabel={(option) => option.name}
                                value={
                                  allProducts.find(
                                    (p) => p.id === parseInt(item.productId)
                                  ) || null
                                }
                                onChange={(event, newValue) => {
                                  handleItemChange(
                                    index,
                                    "productId",
                                    newValue?.id || ""
                                  );
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    placeholder="Selectează materialul"
                                    variant="standard"
                                    size="small"
                                    InputProps={{
                                      ...params.InputProps,
                                      disableUnderline: true,
                                    }}
                                    inputProps={{
                                      ...params.inputProps,
                                      style: { textAlign: "center" },
                                    }}
                                  />
                                )}
                                sx={{
                                  "& .MuiAutocomplete-inputRoot": {
                                    paddingLeft: "6px",
                                    textAlign: "center",
                                  },
                                }}
                                slotProps={{
                                  popper: {
                                    modifiers: [
                                      {
                                        name: "offset",
                                        options: {
                                          offset: [0, 4],
                                        },
                                      },
                                      {
                                        name: "width",
                                        enabled: true,
                                        phase: "beforeWrite",
                                        requires: ["computeStyles"],
                                        fn({ state }) {
                                          state.styles.popper.width = "320px";
                                        },
                                      },
                                    ],
                                  },
                                }}
                              />
                            )}
                          </td>

                          <td className="border p-1 min-w-[300px] max-w-[500px]">
                            <input
                              type="text"
                              value={item.customDescription || ""}
                              onChange={(e) =>
                                handleItemChange(
                                  index,
                                  "customDescription",
                                  e.target.value
                                )
                              }
                              className="w-full text-center bg-transparent border-none"
                              placeholder="Descriere"
                            />
                          </td>

                          <td className="border p-1 w-[10%]">
                            <input
                              type="number"
                              value={
                                item.length === 0 || item.length === "0"
                                  ? ""
                                  : item.length || ""
                              }
                              onChange={(e) =>
                                handleItemChange(
                                  index,
                                  "length",
                                  parseFloat(e.target.value)
                                )
                              }
                              className="w-full text-center bg-transparent border-none"
                              disabled={unitType === "BUC"}
                            />
                          </td>

                          <td className="border p-1 w-[10%]">
                            <input
                              type="number"
                              value={
                                item.width === 0 || item.width === "0"
                                  ? ""
                                  : item.width || ""
                              }
                              onChange={(e) =>
                                handleItemChange(
                                  index,
                                  "width",
                                  parseFloat(e.target.value)
                                )
                              }
                              className="w-full text-center bg-transparent border-none"
                              disabled={unitType === "BUC"}
                            />
                          </td>

                          <td className="border p-1 w-[10%]">
                            <input
                              type="number"
                              value={
                                item.quantity === 0 || item.quantity === "0"
                                  ? ""
                                  : item.quantity || ""
                              }
                              onChange={(e) =>
                                handleItemChange(
                                  index,
                                  "quantity",
                                  parseInt(e.target.value)
                                )
                              }
                              className="w-full text-center bg-transparent border-none"
                              disabled={unitType === "BUC"}
                            />
                          </td>
                          <td className="border p-1 w-[10%]">
                            <input
                              type="number"
                              value={
                                item.quantityMP === 0 || item.quantityMP === "0"
                                  ? ""
                                  : item.quantityMP || ""
                              }
                              onChange={(e) =>
                                handleItemChange(
                                  index,
                                  "quantityMP",
                                  e.target.value
                                )
                              }
                              className="w-full text-center bg-transparent border-none"
                              disabled={unitType === "BUC"}
                            />
                          </td>
                          <td className="border p-1 w-[10%]">
                            <input
                              type="number"
                              value={
                                item.quantityML === 0 || item.quantityML === "0"
                                  ? ""
                                  : item.quantityML || ""
                              }
                              onChange={(e) =>
                                handleItemChange(
                                  index,
                                  "quantityML",
                                  e.target.value
                                )
                              }
                              className="w-full text-center bg-transparent border-none"
                              disabled={unitType === "BUC"}
                            />
                          </td>

                          <td className="border p-1 w-[7%]">
                            <input
                              type="number"
                              value={
                                item.quantityBUC === 0 ||
                                item.quantityBUC === "0"
                                  ? ""
                                  : item.quantityBUC || ""
                              }
                              onChange={(e) =>
                                handleItemChange(
                                  index,
                                  "quantityBUC",
                                  e.target.value
                                )
                              }
                              className="w-full text-center bg-transparent border-none"
                              disabled={unitType === "MP" || unitType === "ML"}
                            />
                          </td>

                          <td className="border p-1 text-center w-[8%]">
                            <IconButton
                              onClick={() => handleRemoveItem(index)}
                              color="error"
                              size="small"
                              title="Șterge"
                            >
                              <DeleteIcon />
                            </IconButton>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
            <div className="flex justify-end mt-4">
              <button
                type="button"
                onClick={handleAddEmptyRow}
                className={`flex items-center gap-2 px-4 py-2 rounded-2xl font-semibold transition ${
                  darkMode
                    ? "bg-blue-700 hover:bg-blue-600 text-white"
                    : "bg-blue-600 hover:bg-blue-500 text-white"
                }`}
              >
                <span className="text-xl">➕</span> Adaugă rând nou
              </button>
            </div>

            <div className="grid grid-cols-3 gap-4 mt-6">
              <div>
                <label
                  className={`block font-semibold mb-1 ${
                    darkMode ? "text-gray-300" : "text-gray-700"
                  }`}
                >
                  Total brut (TVA inclus, fără discount)
                </label>
                <input
                  type="number"
                  value={totalWithTVA}
                  disabled
                  className={`w-full p-2 border rounded-xl ${
                    darkMode
                      ? "bg-gray-800 border-gray-600 text-white"
                      : "bg-white border-gray-300 text-black"
                  }`}
                />
              </div>

              <div>
                <label
                  className={`block font-semibold mb-1 ${
                    darkMode ? "text-gray-300" : "text-gray-700"
                  }`}
                >
                  Preț Preferențial
                </label>
                <input
                  type="number"
                  value={preferentialPrice}
                  onChange={(e) => {
                    setPreferentialPrice(parseFloat(e.target.value));
                    setLastModifiedField("preferentialPrice");
                  }}
                  className={`w-full p-2 border rounded-xl ${
                    darkMode
                      ? "bg-gray-800 border-gray-600 text-white"
                      : "bg-white border-gray-300 text-black"
                  }`}
                />
              </div>

              <div>
                <label
                  className={`block font-semibold mb-1 ${
                    darkMode ? "text-gray-300" : "text-gray-700"
                  }`}
                >
                  Discount (%)
                </label>
                <input
                  type="number"
                  value={discount}
                  onChange={(e) => {
                    setDiscount(parseFloat(e.target.value));
                    setLastModifiedField("discount");
                  }}
                  className={`w-full p-2 border rounded-xl ${
                    darkMode
                      ? "bg-gray-800 border-gray-600 text-white"
                      : "bg-white border-gray-300 text-black"
                  }`}
                />
              </div>
            </div>

            {/* <button
              type="button"
              onClick={() => setIsProductModalOpen(true)}
              className={`w-full py-3 rounded-2xl transition ${
                darkMode
                  ? "bg-blue-700 hover:bg-blue-600 text-white"
                  : "bg-blue-600 hover:bg-blue-500 text-white"
              }`}
            >
              + Adaugă produs
            </button> */}

            <button
              type="submit"
              className={`w-full py-3 rounded-2xl transition ${
                darkMode
                  ? "bg-green-700 hover:bg-green-600 text-white"
                  : "bg-green-600 hover:bg-green-500 text-white"
              }`}
            >
              Salvează Modificările
            </button>
          </form>

          {/* {isProductModalOpen && (
            <OfferProductModal
              isOpen={isProductModalOpen}
              onClose={() => setIsProductModalOpen(false)}
              onAdd={handleAddItem}
              allProducts={allProducts}
              existingProducts={items}
            />
          )} */}
        </div>
      </div>
    )
  );
};

export default EditOfferModal;
